import React from 'react'
import AddIcon from './icons/add'
import TimeRangeRow from './TimeRangeRow'
import TooltipWrapper from '../../../../../../../Components/_newComponents/TooltipWrapper'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 10,
  },
  addButton: {
    width: 'fit-content',
    background: 'transparent',
    border: 'none',
    padding: 0,
  },
}

const TimeRanges = ({
  timeRanges,
  onStartChange,
  onEndChange,
  onRemove,
  validationErrors,
  handleAddTime,
  errorKey = 'breakTimes',
  addButtonTooltip = null,
}) => {
  return (
    <div style={styles.container}>
      {timeRanges.map((timeRange, index) => {
        return (
          <TimeRangeRow
            key={timeRange.id}
            timeRange={timeRange}
            onStartChange={onStartChange}
            onEndChange={onEndChange}
            onRemove={onRemove}
            isLast={index === timeRanges.length - 1}
            validationErrors={validationErrors}
            isRemoveButtonVisible={timeRanges.length !== 1}
            errorKey={errorKey}
          />
        )
      })}
      {timeRanges.length < 3 && (
        <TooltipWrapper
          description={addButtonTooltip ? addButtonTooltip.description : null}
        >
          <button style={styles.addButton} onClick={handleAddTime}>
            <AddIcon />
          </button>
        </TooltipWrapper>
      )}
    </div>
  )
}

export default TimeRanges
